import { JobAreaResponse } from '@doda/api-client/aspida/@types';
import { LinkList } from '../../LinkList';
import { createLinkList, nonNullableText } from '../createLinkList';

/**
 * エリアの関連リンクPropsを生成する
 * @param jobAreaResponse
 */
export const createAreaLinkList = (
  jobAreaResponse?: JobAreaResponse
): LinkList => {
  return {
    separator: '＞',
    list: [
      {
        text: jobAreaResponse?.name ?? '',
        href: jobAreaResponse?.url ?? '',
        childList: createLinkList(jobAreaResponse?.prefectures, ''),
      },
    ].filter(nonNullableText),
  };
};
